import { useContext } from "react";
import { AuthContext } from "../providers/auth-providers";

export const useAuth = () => {
  return useContext(AuthContext);
};
